import AboutSection from './components/AboutSection';
import Services from './components/Services';
import ExpertiseSection from './components/ExpertiseSection';
import WhoIsItFor from './components/WhoIsItFor';
import WhyChooseUs from './components/WhyChooseUs';
import TeamSection from './components/TeamSection';
import Banner from './components/Banner';
import MobileApp from '../../components/MobileApp';
import TestimonialSlider from '../../components/Testimonial';
import SEO from '../../components/SEO';

const Home = () => {
  return (
    <>
      <SEO title="Home" />
      <div className="home-page">
        <Banner />
        <div className="about-service">
          <Services />
        </div>
        <ExpertiseSection />
        <WhyChooseUs />
        <div className="whois-teamsection">
          <WhoIsItFor />
          <AboutSection title="About" subtitle=" Us" isButton={true} />
          {/* <TeamSection /> */}
        </div>
        {/* <MobileApp title="Legalligence" subtitle="Mobile app download" /> */}
        <section className="section-gap-lg p-0">{/* <TestimonialSlider /> */}</section>
      </div>
    </>
  );
};

export default Home;
